import 'configs'

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { TypeRoute } from 'core/TypeRoute'
import { useGoogleMap } from 'hooks/GoogleMapHooks'
import { useEffect } from 'react'
import { MainLayout } from 'components/layouts/MainLayout'
import { HomePage } from 'components/pages/HomePage'
import { StoreLayout } from 'components/layouts/StoreLayout'
import { StoreInfoPage } from 'components/pages/StoreInfoPage'
import { OrderingLayout } from 'components/layouts/OrderingLayout'
import { OrderingPage } from 'components/pages/OrderingPage'
import { SubmitOrderPage } from 'components/pages/SubmitOrderPage'
import { TableOrderingPage } from 'components/pages/TableOrderingPage'
import { TableSubmitOrderPage } from 'components/pages/TableSubmitOrderPage'
import { TableOrderingLayout } from 'components/layouts/TableOrderingLayout'
import { SignInPage } from 'components/pages/SignInPage'
import { RedirectPage } from 'components/pages/RedirectPage'
import { UserProfilePage } from 'components/pages/UserProfilePage'
import { PrivacyPolicyPage } from 'components/pages/PrivacyPolicyPage'
import { CartLayout } from 'components/layouts/CartLayout'
import { NoCartLayout } from 'components/layouts/NoCartLayout'

function App() {
  const { loadGoogleMapScript } = useGoogleMap()

  useEffect(() => loadGoogleMapScript(), [loadGoogleMapScript])

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route
            path={TypeRoute.SignIn}
            element={
              <NoCartLayout>
                <SignInPage />
              </NoCartLayout>
            }
          />
          <Route path={TypeRoute.Redirect} element={<RedirectPage />} />
          <Route
            path={TypeRoute.Home}
            element={
              <NoCartLayout>
                <HomePage />
              </NoCartLayout>
            }
          />
          <Route
            path={TypeRoute.UserProfile}
            element={
              <NoCartLayout>
                <UserProfilePage />
              </NoCartLayout>
            }
          />
          <Route
            path={TypeRoute.PrivacyPolicy}
            element={
              <NoCartLayout>
                <PrivacyPolicyPage />
              </NoCartLayout>
            }
          />
          <Route path={TypeRoute.StoreInfo} element={<StoreLayout />}>
            <Route
              index
              element={
                <NoCartLayout>
                  <StoreInfoPage />
                </NoCartLayout>
              }
            />

            <Route path={TypeRoute.Ordering} element={<OrderingLayout />}>
              <Route
                index
                element={
                  <CartLayout>
                    <OrderingPage />
                  </CartLayout>
                }
              />
              <Route
                path={TypeRoute.SubmitOrder}
                element={
                  <NoCartLayout>
                    <SubmitOrderPage />
                  </NoCartLayout>
                }
              />
            </Route>

            <Route
              path={TypeRoute.TableOrdering}
              element={<TableOrderingLayout />}
            >
              <Route
                index
                element={
                  <CartLayout>
                    <TableOrderingPage />
                  </CartLayout>
                }
              />
              <Route
                path={TypeRoute.TableSubmitOrder}
                element={
                  <NoCartLayout>
                    <TableSubmitOrderPage />
                  </NoCartLayout>
                }
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
